import { t } from 'i18next';

export type TDeviceStatus = 'Operação'|'Máquina desenergizada'|'Desinstalação forçada'|'Dispositivo removido';
export type DeviceStatusKeys = keyof typeof DeviceStatus;

export enum DeviceStatus {
  OPERATION = 'Operação',
  MACHINE_WITHOUT_ENERGY = 'Máquina desenergizada',
  FORCED_UNINSTALL = 'Desinstalação forçada',
  DEVICE_REMOVED = 'Dispositivo removido'
}

export const getDeviceStatusKey = (value: TDeviceStatus | null | undefined): DeviceStatusKeys | null => {
  if (!value) return null;
  const key = (Object.keys(DeviceStatus) as DeviceStatusKeys[]).find((k) => DeviceStatus[k] === value);
  return key ?? null;
};

export const DeviceStatusOpts: { name: string; value: DeviceStatusKeys }[] = [
  { name: t('emOperacao'), value: 'OPERATION' },
  { name: t('maquinaDesernergizada'), value: 'MACHINE_WITHOUT_ENERGY' },
  { name: t('desinstalacaoForcada'), value: 'FORCED_UNINSTALL' },
  { name: t('dispositivoRemovido'), value: 'DEVICE_REMOVED' },
];

export const DeviceStatusAllOpts: { label: string; value: DeviceStatusKeys }[] = DeviceStatusOpts.map(
  ({ name, value }) => ({ label: name, value }),
);
